import React from "react";
import PropTypes from "prop-types";
import {
  DESCRIPTION_CHEVRON_DOWN_PATH,
  DESCRIPTION_CHEVRON_FILL,
  DESCRIPTION_CHEVRON_SIZE,
  DESCRIPTION_CHEVRON_UP_PATH,
} from "../../../../shared/description-chevrons.js";
import styles from "./ProductDescriptionBlock.module.css";

export default function DescriptionChevron({ expanded = false }) {
  return (
    <svg
      className={styles.chevronIcon}
      width={DESCRIPTION_CHEVRON_SIZE}
      height={DESCRIPTION_CHEVRON_SIZE}
      viewBox={`0 0 ${DESCRIPTION_CHEVRON_SIZE} ${DESCRIPTION_CHEVRON_SIZE}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d={expanded ? DESCRIPTION_CHEVRON_UP_PATH : DESCRIPTION_CHEVRON_DOWN_PATH}
        fill={DESCRIPTION_CHEVRON_FILL}
      />
    </svg>
  );
}

DescriptionChevron.propTypes = {
  expanded: PropTypes.bool,
};
